import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'rds-c-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdsChipsComponent {
  @HostBinding('class.rds-c-chips') hostClass = true;

  /** Aria label to attach to the mat-chip-list */
  @Input() ariaLabel: string | null | undefined;
  @Input() chips: Array<RdsChip> = [];
  /** Whether the chips should be rendered more compact */
  @Input() dense = false;
  @Input() disabled = false;
  @Input() removable = true;
  /** Whether to enable reordering of the chip list */
  @HostBinding('class.rds-c-chips-orderable')
  @Input()
  orderable = false;
  @Input() selectable = true;
  /* Direction the chip list is displayed. Defaults to row. */
  @HostBinding('class.rds-c-chips-vertical')
  @Input()
  vertical = false;
  /** Whether the chip labels should wrap */
  @Input() wrapLabels = false;

  @Output() removed = new EventEmitter<RdsChip>();
  /** Emits the list in the new order */
  @Output() reordered = new EventEmitter<RdsChip[]>();
  @Output() selected = new EventEmitter<RdsChip>();

  handleDrop(event: CdkDragDrop<string[]>) {
    const updatedList = [...this.chips];
    moveItemInArray(updatedList, event.previousIndex, event.currentIndex);
    this.reordered.emit(updatedList);
  }

  handleSelect(chip: RdsChip) {
    if (this.selectable) {
      this.selected.emit(chip);
    }
  }

  handleRemove(chip: RdsChip) {
    if (this.removable) {
      this.removed.emit(chip);
    }
  }
}

export class RdsChip {
  constructor(public label: string, public id: string = label) {}
}
